function isEmpty(source: null | [] | object | string): boolean | undefined {
    if (source === null) {
        return true;
    }
    if (Array.isArray(source)) {
        return !source.length;
    }
    if (source instanceof Object) {
        return !Object.keys(source).length;
    }
    if (typeof source === 'string') {
        return !source.trim().length;
    }
};

export default isEmpty;